import { Container } from 'reactstrap';
import ModifFormVybaveni from '../comp/ModifFormVybaveni'

function NewVybaveni() {
    return (
    <Container>
        <ModifFormVybaveni edit={false}  />
    </Container>)
}
export default NewVybaveni